import { gql } from "@apollo/client"

export const CREATE_LICENSE_POOL = gql`
  mutation createLicensePool($data: CreateLicensePoolInput!) {
    licensePool {
      createLicensePool(data: $data) {
        id
        orgId
        orgType
        seatCount
        startDate
        endDate
        createdAt
        createdBy
        isDeleted
        schoolName
      }
    }
  }
`

export const UPDATE_LICENSE_POOL = gql`
  mutation updateLicensePool($id: String!, $data: UpdateLicensePoolInput!) {
    licensePool {
      updateLicensePool(id: $id, data: $data) {
        id
        orgId
        orgType
        seatCount
        startDate
        endDate
        createdAt
        updatedAt
        createdBy
        isDeleted
        schoolName
      }
    }
  }
`

export const DELETE_LICENSE_POOL = gql`
  mutation deleteLicensePool($data: DeleteLicensePoolInput!) {
    licensePool {
      deleteLicensePool(data: $data) {
        id
        isDeleted
      }
    }
  }
`

export const DELETE_BATCH_LICENSE_POOLS = gql`
  mutation deleteBatchLicensePools($data: RemoveBatchLicensePoolRequest!) {
    licensePool {
      removeBatch(data: $data)
    }
  }
`

export const IMPORT_LICENSE_POOLS_FROM_CSV = gql`
  mutation importLicensePoolsFromCSV($data: ImportLicensePoolsFromCSVInput!) {
    licensePool {
      importLicensePoolsFromCSV(data: $data) {
        fileId
        success
        message
        rowResults {
          rowNumber
          status
          districtName
          schoolName
          error
        }
        summary {
          total
          created
          updated
          failed
        }
      }
    }
  }
`
